module.exports = "<div class=\"container\" >\n  <div class=\"properties-listing spacer\" id=\"myCarousel\">  \n    <h2>{{HomeAd.Property}}</h2>\n    \n    <div id=\"owl-example\" class=\"owl-carousel\">\n \n        <div class=\"properties\" *ngFor=\"let item of defaultSchema.Items\"   >\n          <tn-ads-list-item [adData]=\"item\" [routerLink]=\"['/detail', item.Code]\"></tn-ads-list-item>  \n        </div> \n \n    </div>\n  </div>\n</div>\n "


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/tnadslist.component.html
// module id = ../../../../../src/app/themes/default/html/tnadslist.component.html
// module chunks = 1